const mapUserGroupStore = store => {
  return {
    id: store.id,
    name: store.name,
  }
}

const mapUserGroup = group => {
  return {
    id: group.id,
    name: group.name,
    store: mapUserGroupStore(group.store),
  }
}

export const transformResponseUserGroups = groups => {
  if (!groups) return []

  return groups.map(mapUserGroup)
}
